<app-module-list
  [selectedModules]="license.module_list"
  (moduleChangeEvent)="moduleChange($event)"></app-module-list>
<div class="d-flex m16">
  <div class="f-gr-1"></div>
  <button mat-raised-button color="primary" (click)="save()" i18n>Save</button>
</div>
